var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrackets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 55,
    fill: "none",
    viewBox: "0 0 56 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#intro-brackets-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#07A956",
    fillRule: "evenodd",
    d: "M35.545 38.763a2.182 2.182 0 0 1 0-3.085l3.526-3.527a7.17 7.17 0 0 0 0-10.139l-3.526-3.526A2.182 2.182 0 1 1 38.63 15.4l5.069 5.07a9.351 9.351 0 0 1 0 13.224l-5.07 5.07a2.182 2.182 0 0 1-3.085 0Zm-14.547 0a2.182 2.182 0 0 0 0-3.085L17.47 32.15a7.17 7.17 0 0 1 0-10.139l3.527-3.526a2.182 2.182 0 1 0-3.086-3.086l-5.07 5.07a9.351 9.351 0 0 0 0 13.224l5.07 5.07a2.182 2.182 0 0 0 3.086 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#intro-brackets-b)",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M35.545 38.763a2.182 2.182 0 0 1 0-3.085l3.526-3.527a7.17 7.17 0 0 0 0-10.139l-3.526-3.526A2.182 2.182 0 1 1 38.63 15.4l5.069 5.07a9.351 9.351 0 0 1 0 13.224l-5.07 5.07a2.182 2.182 0 0 1-3.085 0Zm-14.547 0a2.182 2.182 0 0 0 0-3.085L17.47 32.15a7.17 7.17 0 0 1 0-10.139l3.527-3.526a2.182 2.182 0 1 0-3.086-3.086l-5.07 5.07a9.351 9.351 0 0 0 0 13.224l5.07 5.07a2.182 2.182 0 0 0 3.086 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "intro-brackets-b",
    x1: 28.271,
    x2: 28.271,
    y1: 13.857,
    y2: 40.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E467B"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "intro-brackets-a",
    width: 55.232,
    height: 43.537,
    x: 0.656,
    y: 10.037,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.575
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.362
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.113725 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2427_47400"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.724
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.724
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.113725 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2427_47400",
    result: "effect2_dropShadow_2427_47400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2427_47400",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrackets);
export default __webpack_public_path__ + "09d9ba8e778f53241a3cf7d0c64a0e30.svg";
export { ForwardRef as ReactComponent };